import DataStrategy from 'components/data-strategy/DataStrategy.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import fs from "fs";
import React from "react";

export default function DataEngineeringPage({blogs,casestudies}){
  return(
  <DataStrategy casestudies={casestudies} />
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });
  
  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);

  return {
    props: {
      meta: {
        title: "Data Strategy",
        description: "We’ve been building data solutions for almost 20 years. Consider your legal, social, and technical needs covered.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      casestudies: caseStudiesList,
    },
  };
};